import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { fileNames } from 'Constants/imageUrls';
import Button from 'Components/Button/Button';
import { withConfig } from 'HOCs/withConfig/withConfig';
import { compose } from 'redux';

import css from './NotFoundV2.scss';

export const NotFoundV2 = ({ intl, marketConfig }) => {
    const errorIcon = marketConfig.get('olxAutos', 'noFoundLogo');

    return (
        <div className={ css.notFoundV2 }>
            <ImageWrapper
                fileName={ errorIcon || fileNames.ERROR_STATE_MXCL }
                className={ css.notFoundV2__image }
                data-aut-id="Error_Image" />
            <div className={ css.notFoundV2__errorTitle }>
                {
                    intl.formatMessage({
                        id: 'notFoundV2ErrorTitle',
                        defaultMessage: 'Error state 404'
                    })
                }
            </div>
            <div className={ css.notFoundV2__errorDescription }>
                {
                    intl.formatMessage({
                        id: 'notFoundV2ErrorDescription',
                        defaultMessage: 'The requested page does not exist. The link you clicked may be broken or the page may have been removed'
                    })
                }
            </div>
            <Button
                href={ '/' }
                className={ css.notFoundV2__homeButton }
                type="primary"
                data-aut-id="HomePageButton"
            >{
                    intl.formatMessage({
                        id: 'notFoundV2HomeButtonLabel',
                        defaultMessage: 'Go back home'
                    })
                }</Button>
        </div>
    );
};

NotFoundV2.propTypes = {

    intl: PropTypes.shape({
        formatMessage: PropTypes.func
    }),
    marketConfig: PropTypes.shape({
        get: PropTypes.func
    })
};

export default compose(
    injectIntl,
    withConfig('marketConfig')
)(NotFoundV2);
